import type { CatalogueEntry } from "../types";
import imageLight from "../images/postcode-boundaries.light.webp";
import imageDark from "../images/postcode-boundaries.dark.webp";

export const entry: CatalogueEntry = {
  slug: "postcode-boundaries",
  displayName: `Postcode Boundaries`,
  datasetProductCode: `POSTCODE BOUNDARIES`,
  subtitle: `Spatial Representation for Postcode Area Analysis and Logistics.`,
  shortDescription: `The Postcode Boundaries Dataset provides a spatial representation of postcode information used by Australia Post to support their mail management and delivery operations. Postcodes are represented using both a polygon and point geometry.
The dataset is designed to be a a single national point of access to Australian Postcode Boundary information. `,
  metadata: {
    dateAdded: 1204156800000,
    dataType: ["Polygons"],
    theme: `Administrative Boundaries`,
    totalFeatureCount: 749,
    updateFrequency: `As Deemed Necessary`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/postcodes_release/en/stable/index.html#document-index`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/docs_postcode_desc/en/stable/`,
  imageLight,
  imageDark,
  searchTags: `National Postcode Boundaries Geoscape Postcode Boundaries Codes Logistics Mail Mail Delivery Postal Logistics Postal Services Postcodes Regional Planning Spatial Analysis Zones`,
  detail: () => import("../details/postcode-boundaries").then((m) => m.detail),
};

export default entry;
